import {ModuleComponent} from "../../js/module-component";

export class ModFooter extends ModuleComponent{
    ready(){
        super.ready();
    }
}
